export default {
    menu_label: 'Network Intelligence',

    nav: {
        overview: 'Overview',
        constraints: 'Constraint Intelligence',
    },

    filters: {
        time_range: 'Time Range',
    },

    overview: {
        title: 'Network Intelligence Overview',
        subtitle: 'Real-time analytics and insights into your referral network',
        loading: 'Loading intelligence data…',
        error: 'Unable to load intelligence data. Please try again.',
        empty: 'No intelligence data for the selected period.',
    },

    constraints: {
        title: 'Constraint Intelligence',
        subtitle: 'Understand why referrals become constrained',
        loading: 'Loading constraint data…',
        error: 'Unable to load constraint data. Please try again.',
        empty: 'No constraint data for the selected period.',
        table: {
            reason_code: 'Reason Code',
            frequency: 'Frequency',
            percent: 'Share',
        },
    },

    kpis: {
        referral_completion_rate: 'Referral Completion Rate',
        matchable_rate: 'Matchable Rate',
        constrained_rate: 'Constrained Rate',
        unmatchable_rate: 'Unmatchable Rate',
        referrals_created: 'Referrals Created',
    },

    charts: {
        referral_funnel: 'Referral Funnel',
        constraint_breakdown: 'Constraint Breakdown',
        reason_ranking: 'Top Reason Codes',
        drop_off: 'Drop-off: {percent}%',
    },

    funnel: {
        created: 'Created',
        matchable: 'Matchable',
        accepted: 'Accepted',
        scheduled: 'Scheduled',
        completed: 'Completed',
    },
}
